import getXyHeaders from '@/utils/getXyHeaders';
import getXyManagePathPrefix from '@/utils/getXyManagePathPrefix';
import { wujiRequest } from './utils/wujiRequest';
import { isOffline } from './utils/wujiWindow';
import { requestWithCache } from './utils/cache';
export async function getRuntimeConfig(options) {
    return await requestWithCache(options, async (options) => {
        const { collectionId, projectId, pageId, envId, simplifyCgiSchema = true, } = options;
        return await wujiRequest({
            url: `${getXyManagePathPrefix({ envId })}/datasource/collection/${collectionId}${addJsonPrefixIfNeeded()}?projectid=${projectId}&pageid=${pageId}`,
            method: 'get',
            headers: getRuntimeHeaders(simplifyCgiSchema),
        });
    });
}
export async function getRuntimeConfigList(options) {
    const { collectionIds, projectId, pageId, envId, simplifyCgiSchema = true, } = options;
    if (collectionIds.length <= 0)
        return [];
    const filter = collectionIds.map(id => `collectionId="${id}"`).join('|');
    const res = await wujiRequest({
        url: `${getXyManagePathPrefix({ envId })}/datasource/collection${addJsonPrefixIfNeeded()}?filter=${encodeURIComponent(`${filter}`)}&projectid=${projectId}&pageid=${pageId}`,
        headers: getRuntimeHeaders(simplifyCgiSchema),
    });
    return res;
}
function addJsonPrefixIfNeeded() {
    return isOffline() ? '.json' : '';
}
function getRuntimeHeaders(simplifyCgiSchema) {
    if (isOffline())
        return {};
    const headers = getXyHeaders();
    if (simplifyCgiSchema) {
        headers['xy-simplify-cgi-schema'] = 'simplify';
    }
    return headers;
}
